import React from 'react';

const ProductosListaHead = (props) => {
	
	console.log(props)
	var titulo="titulo"
	var descripcion="DESC"
	var contenido=""
	var img=""

	if(props.datos && props.datos.length>0  ){
		console.log(props)
		var catselect = props.datos[0].categorias.filter(o => {
			console.log(o)
			if(parseInt(o.id) === parseInt(props.categoria)){
        		return o;
			}
      	});
		console.log(catselect)
      	//titulo=props.datos[0].rubro +" "+ catselect[0].categoria
      	titulo= catselect[0].nombre
		descripcion=catselect[0].descripcion
		contenido=catselect[0].xtra
		img=catselect[0].img
	}



	return(
		<article className="hero bg-cover" >

			<div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
			  <div className="carousel-inner headColor">
					<div className={ "carousel-item row  p-3 p-md-5  active"}>
				<div className="d-flex flex-row justify-content-center">
					<div className="headerMod">
								<div className="headData  col-12  col-md-6">
					        <h1 className="hero-title"> {titulo}</h1>
					        <p className="hero-text">{descripcion}</p>
					    </div>
								<img className="headImg  col-12  col-md-6" src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F"+img+"?alt=media"} alt={titulo} />
		        	</div>
	        	</div>
				</div>
			  </div>
			</div>

    		<div className="container hero-container">
		        <div className="hero-content">
		        	<div dangerouslySetInnerHTML={{__html:contenido}} />
		        </div>
    		</div>
		</article>
		)
}

export default ProductosListaHead;



// WEBPACK FOOTER //
// ./src/components/productoListaHead.js